export default function RankingSection() {
  const rankings = [
    { rank: 1, title: '顶流男星深夜密会神秘女子', heat: '🔥 1280万', trend: 'up', change: '+320%' },
    { rank: 2, title: '千万粉丝网红直播翻车维权', heat: '🔥 1056万', trend: 'up', change: '+215%' },
    { rank: 3, title: '综艺导演潜规则多人发声', heat: '🔥 897万', trend: 'up', change: '+189%' },
    { rank: 4, title: '知名品牌代言人突然解约', heat: '⚡ 765万', trend: 'up', change: '+156%' },
    { rank: 5, title: '三位艺人被税务部门约谈', heat: '⚡ 654万', trend: 'up', change: '+132%' },
    { rank: 6, title: '某女星疑似隐婚生子曝光', heat: '⚡ 543万', trend: 'new', change: 'NEW' },
  ];

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-400 bg-accent-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-trophy-line"></i>
            Hot Ranking
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500">实时追踪今日黑料最新热度排名</p>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-xl overflow-hidden">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-5 py-4 border-b border-background-200/40 last:border-b-0 hover:bg-background-100/50 transition-colors cursor-pointer"
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold ${
                item.rank === 1
                  ? 'bg-accent-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-400/80 text-white'
                  : item.rank === 3
                  ? 'bg-primary-500 text-background-950'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-200 truncate">{item.title}</h3>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-300 whitespace-nowrap">{item.heat}</span>
                <span className={`text-xs font-semibold whitespace-nowrap ${
                  item.trend === 'new' ? 'text-accent-400' : 'text-primary-400'
                }`}>
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}